import { Constants } from './constants';

class UrlFactory {
    constructor() {
        this.apiUrl = Constants.ENVIRONMENT['DEVELOPMENT'];
        this.tvfcuUrl = Constants.ENVIRONMENT['TVFCU_ENV'];
        this.clockoutApiUrl = Constants.ENVIRONMENT['CLOCKOUT_TEST_API'];
    }

    createFiUrl(aba) {
        return `${this.clockoutApiUrl}/api/consumer/fi/${aba}`;
    }

    createContextUrl(nonce) {
        return `${this.tvfcuUrl}/context/${nonce}`;
    }
}

export default UrlFactory;
